import { render, staticRenderFns } from "./NavigationMealsAdd.vue?vue&type=template&id=32700b73&scoped=true"
import script from "./NavigationMealsAdd.vue?vue&type=script&lang=js"
export * from "./NavigationMealsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32700b73",
  null
  
)

export default component.exports